<template>
    <component :is="component" :routeData="routeData" v-if="component" />
</template>
<script>

function lazyLoad(module) {
    return() => import(`./${module}`)
}

export default {
    name: 'modules',
    props: ['moduleType', 'routeData'],
    data() {
        return {
            component: null,
        }
    },
    mounted() {
        //console.log(this.moduleType, !!this.moduleType)
        /*if (this.moduleType) {
            this.component = () => import(`./${this.moduleType}`)
        } else {
            this.component = () => import('./default')
        }*/
        /*if (this.moduleType) {
            this.component = () => import(`./${this.moduleType}`)
        } else if (this.routeData.modtype) {
            this.component = () => import(`./${this.routeData.modtype}`)
        } else {
            this.component = () => import('./default')
        }*/
        if (this.moduleType) {
            this.component = lazyLoad(this.moduleType)
        } else if (this.routeData.modtype) {
            this.component = lazyLoad(this.routeData.modtype)
        } else {
            this.component = lazyLoad('default')
        }
    },
}
</script>
<style>
</style>